import {connect} from "react-redux";
import CompleteUCDActivity from "./Complete";
import {bindActionCreators} from "redux";
import {
    markAttendances,
    getActivity,
} from "../../../../../service/Dealer/action";
import {getJourney} from "../../../../../service/Journey/action";
import { isCheckout } from "../../../../../service/CarService/action";
import {accountDetailsById} from "../../../../../service/Account/action";
import {viewActivity} from "../../../../../service/Activity/action";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {saveActivity} from "../../../../../service/DCC/action";

const mapStateToProps = (state) => ({
    markAttendanceDetails: state.Dealer.markAttendance,
    getActivityDetails: state.Dealer.getActivity,
    isCheckoutDetails:state.CarService.isCheckout,
    getUserJourney: state.Journey.getUserJourney,
    accountDetails:state.Dropdown.accountDetailsById,
    activityByIdDetails:state.Activity.activityByIdDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    NewActivityDetails:state.DCC.saveActivityRes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            markAttendances,
            getActivity,
            saveActivity,
            isCheckout,
            getJourney,
            accountDetailsById,
            viewActivity,
            documentUploadUrlPublic
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteUCDActivity);
